import router from './router';
import store from './store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, setToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { handleIintFinanceRoute } from '@/utils/addRoute';
import { sassMenuHide } from '@/api/systemSet';

// 本地开发时手动设置token
// if (process.env.VUE_APP_ENV === 'development') {
//   /**
//    * 各开发需要在项目根目录创建 `.env.local` （不进入代码仓库）
//    * 以满足各自本地开发环境需要，避免更改 token 引起的代码冲突
//    * # d表示dev开发环境,t表示测试环境
//    * 增加环境配置变量 VUE_APP_BASE_DOMAIN_PREFIX = d
//    */
//   debugger
//   setToken(process.env.VUE_APP_TOKEN);
// }
NProgress.configure({ showSpinner: false }); // NProgress Configuration
router.beforeEach(async (to, from, next) => {
  // debugger
  //判断是否是文章详情页面
  const _isArticle = to.path.includes('/articleDetail/');
  const _isSellCard = to.path.includes('/sellCard/');

  const { token } = to.query || {};
  store.commit('app/SET_CURRENT_COLOR_LOGO');
  //判断是否在轻赢宝官网跳转的
  if (to.query.token) {
    setToken(to.query.token, 'key');
    store.commit('user/SET_APPID', to.query.appid);
    setTimeout(() => {
      sassMenuHide().then((datares) => {
        store.commit('user/SET_sassMenuHide_INFO', datares.data);
        localStorage.setItem('sassMenuHide', JSON.stringify(datares.data));
        if (to.query.isEn == '1') {
          store.commit('app/SET_LANGUAGE', 'en-US');
        }
        router.push({
          path: '/',
        });
      });
      // store.dispatch("dialingCode/fetchDialingCodeList")
    }, 1000);
    return;
  }

  if (window.location.href.indexOf('from=byh') > -1 && token) {
    // 判断是否从别样红跳转过来的
    setToken(token, 'byh_token');
  }
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);
  // determine whether the user has logged in
  if (getToken('key')) {
    // store.dispatch("dialingCode/fetchDialingCodeList")
    const hasUserInfo = store.getters.name;
    if (_isArticle) {
      console.log('article页面');
      //当是文章页面的时候，去除登录限制，因为要兼容app和小程序端
      next();
      return false;
    }
    if (_isSellCard) {
      console.log('isSellCard页面');
      //当是文章页面的时候，去除登录限制，因为要兼容app和小程序端
      next();
      return false;
    }
    if (to.path.includes('/login/')) {
      console.log('isSellCard页面');
      //当是文章页面的时候，去除登录限制，因为要兼容app和小程序端
      next();
      return false;
    }

    if (hasUserInfo) {
      if (to.path.includes('/finance/')) {
        await handleIintFinanceRoute();
      }
      next();
    } else {
      if (!store.getters.authList.length) {
        try {
          const getUserInfo = store.dispatch('user/getInfo');
          await getUserInfo;
          /**
           * 需要全局使用并且需要在页面渲染前获取结果的接口可以写在这里，像打印配置、硬件等好多页面需要使用的功能
           * 但是要注意判断是否从别样红过来的
           */
          let queryPrintSettings = null;
          if (!(window.location.href.indexOf('from=byh') > -1)) {
            if (!store.getters.printSettings) {
              // 打印配置
              queryPrintSettings = store.dispatch('user/getHotelPrintSetting');
            }
            if (!store.getters.serviveInfo) {
              store.dispatch('user/fetchServieInfo');
            }
            // if (!store.getters.reportAjaxStatus) { // 获取报表的权限问题
            //   store.dispatch('user/getReportAuth')
            // }
          }
          // await store.dispatch('user/judgeIsCheckInGrayEnvAction')
          const routerList = await store.dispatch('user/getAuthList', to);
          await router.addRoutes(routerList);
          // console.log(routerList, router);
          await queryPrintSettings;
          /**
           * 现付账账套列表刷新时，因为是动态路由，所以重定向到账套列表的第一个路由
           */
          if (to.path.includes('/account')) {
            next({ path: '/account', replace: true });
          } else {
            if (!store.getters.isFinMenus) {
              next({ path: '/finance/mangement', replace: true });
            } else {
              // 如果是在散客步入页面进行酒店切换的话，需要跳转到方涛页面
              if (
                to.path.includes('/room-status/checkIn') &&
                !to.path.endsWith(store.getters.hotelCode)
              ) {
                next({ path: '/room-status/real-time', replace: true });
              } else {
                next({ ...to, replace: true });
              }
            }
          }
        } catch (error) {
          console.log('请求异常', error);
        }
      } else {
        next();
      }
    }
    NProgress.done();
  } else if (to.path.includes('/login/')) {
    next();
  } else if (_isArticle) {
    console.log('article');
    //当是文章页面的时候，去除登录限制，因为要兼容app和小程序端
    next();
  } else if (_isSellCard) {
    //当是文章页面的时候，去除登录限制，因为要兼容app和小程序端
    next();
  } else {
    store.dispatch('user/logout');
    NProgress.done();
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
